const t = "_wrapper_f8w55_1", n = "_neutral_f8w55_14", r = "_important_f8w55_17", o = "_icon_f8w55_26", _ = {
  wrapper: t,
  neutral: n,
  important: r,
  icon: o
};
export {
  _ as default,
  o as icon,
  r as important,
  n as neutral,
  t as wrapper
};
